import usersRoutes from './users/user-routes';
import notificationsRoutes from './notifications/notifications-routes';
import callsRoutes from './calls/calls-routes';
import appSettingsRoutes from './apps_settings/apps-settings-routes';
import deliveryRoutes from './deliveries/deliveries-routes';
import templatesRoutes from './notification_templates/templates-routes';
import accountsRoutes from '@/app/admin/account_mailers/accounts-routes';
import outgoingPhonesRoutes from "@/app/admin/outgoing_phones/outgoing_phones-routes";

const adminRoutes = [
  ...callsRoutes,
  ...notificationsRoutes,
  ...usersRoutes,
  ...appSettingsRoutes,
  ...deliveryRoutes,
  ...templatesRoutes,
  ...accountsRoutes,
  ...outgoingPhonesRoutes,
];

export default adminRoutes;
